import { render, staticRenderFns } from "./Transfers.vue?vue&type=template&id=25990388&scoped=true"
import script from "./Transfers.vue?vue&type=script&lang=js"
export * from "./Transfers.vue?vue&type=script&lang=js"
import style0 from "./Transfers.vue?vue&type=style&index=0&id=25990388&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25990388",
  null
  
)

export default component.exports